<template>
    <div>
       
    <main class="main">
            <div class="bredcumb">
                <div class="container">
                    <ul>
                         <li><router-link to="/index"><a href="/index">首頁</a></router-link></li>
                        <li>鯨選課程</li>
                    </ul>
                </div>
            </div>

            <!--常見問題開始-->

            <div class="bodyContent">
                <div class="container">
                    <h1>常見問題</h1>
                    <div class="faq">

                        
                        <div class="category">
                            <ul>
                                <li class="current"><a id="faq_all" href="javascript:void(0);">全部問題</a></li>
                                <li><a id="faq_about" href="javascript:void(0);">關於一刻鯨選</a></li>
                                <li><a id="faq_lecture" href="javascript:void(0);">課程及講師</a></li>
                                <li><a id="faq_purchase" href="javascript:void(0);">購買</a></li>
                                <li><a id="faq_refund" href="javascript:void(0);">退費</a></li>
                                <li><a id="faq_function" href="javascript:void(0);">App功能</a></li>
                                <li><a id="faq_login" href="javascript:void(0);">登入</a></li>
                            </ul>
                        </div>

                        <ul class="accordion uploadArea">

                            <!-- 關於一刻鯨選 li class="faq_about-->
                            <li class="faq_about">
                                <!-- 問題 -->
                                <a class="toggle" href="javascript:void(0);">為什麼你們叫做一刻鯨選，和鯨魚有什麼關係？</a>
                                <!-- 解答 -->
                                <div class="inner">
                                    <p>
                                        一刻鯨選傳達了我們服務的核心宗旨，希望聽眾只需要短短一刻15分鐘的時間，就可以在每天生活的每一刻，不管是通勤、開車、運動、做家事、陪小孩，或是睡前，輕鬆品味好聽、有料又實用的知識。
                                    </p>
                                    <p>
                                        鯨魚（抹香鯨）是生物界聽力相當優異的動物，並且能在海洋中深入潛出、優游自在，一如我們對自己的期待，希望將浩瀚的學問知識，用有系統的方式，帶給聽眾聲音上的聽覺享受。
                                    </p>
                                </div>
                            </li>
                            <li class="faq_about">
                                <a class="toggle" href="javascript:void(0);">什麼樣的人適合使用你們的服務？</a>
                                <div class="inner">
                                    <p>
                                        一刻鯨選適合每個想要用知識充滿每一刻的讀書人、知識工作者。<br>
                                        我們有商業管理的實用進修課程，幫忙碌的上班族打打氣、再上路；<br>
                                        我們有文學史學的賞析文化課程，幫聽眾拾回早已丟棄的文學經典，再次啟發；<br>
                                        我們有生活品味的藝術美學課程，還有心靈療癒課程，讓緊繃的心得以柔軟；<br>
                                        未來我們也會陸續推出醫藥專家的實用保健課程，照顧自己照顧他人，簡單可得。
                                    </p>
                                </div>
                            </li>

                            <!-- 課程及講師 li class="faq_lecture"-->
                            <li class="faq_lecture">
                                <a class="toggle" href="javascript:void(0);">我要如何和課程講師聯繫？</a>
                                <div class="inner">
                                    <p>
                                        目前我們沒有開放和講師直接聯繫，如果你有疑問想和講師討論，請聯繫講師的社群，或是寄信到我們的客服信箱（<A Href="mailto:jinfm.hi@gmail.com">jinfm.hi@gmail.com</A>），由我們轉寄給講師。
                                    </p>
                                    <p>
                                        未來我們會發展留言機制，這樣子就可以在購買課程的下方和老師進行討論。
                                    </p>
                                </div>
                            </li>
                            <li class="faq_lecture">
                                <a class="toggle" href="javascript:void(0);">如果我想聽的課程你們沒有，我可以建議嗎？</a>
                                <div class="inner">
                                    <p>
                                        我們很歡迎，您可以在客服信箱（<A Href="mailto:jinfm.hi@gmail.com">jinfm.hi@gmail.com</A>）告訴我們您想要聽的課程類別或建議講師，我們會在評估後進行開發，謝謝！
                                    </p>
                                </div>
                            </li>

                            <!-- 購買 li class="faq_purchase"-->
                            <li class="faq_purchase">
                                <a class="toggle" href="javascript:void(0);">要如何使用一刻鯨選的服務？</a>
                                <div class="inner">
                                    <p>
                                        您可以先試聽課程，確認課程符合您的需求後，使用本平台支援的付款方式購買「點數」，並且用「點數」兌換課程來取得收聽的權利。
                                    </p>
                                    <p>
                                        您可以在網站上試聽，但目前本平台僅支援於「一刻鯨選」 App 內購買點數、兌換課程。
                                    </p>
                                </div>
                            </li>
                            <li class="faq_purchase">
                                <a class="toggle" href="javascript:void(0);">請問要如何購買點數？</a>
                                <div class="inner">
                                    <p>
                                        目前您可下載「一刻鯨選」App，使用 Google Play 「應用程式內購」 或 Apple「App 內購買」購買點數。
                                    </p>
                                    <p>
                                        方法一：<br>
                                        當您購買課程時，如果點數不足，您可以選擇「立即加值」，透過「一刻鯨選」App 支援的方式來購買點數。
                                    </p>
                                    <div class="descriptionImg">
										<figure><img src="@/assets/images/faq/recharge_1_0.jpg" alt="課程頁面"></figure>
                                        <figure><img src="@/assets/images/faq/recharge_1_1.jpg" alt="立即加值"></figure>
                                        <figure><img src="@/assets/images/faq/recharge_1_2.jpg" alt="加值畫面"></figure>
                                    </div>
                                    <p>
                                        方法二：<br>
                                        您可以點選「一刻鯨選」 App 下方的「設定」<span class="img"><img src="@/assets/images/faq/icon1_1_1.png" alt="設定"></span>，在「錢包餘額」旁點按「加值」來購買點數。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><img src="@/assets/images/faq/recharge_2_1.jpg" alt="加值"></figure>
                                        <figure><img src="@/assets/images/faq/recharge_2_2.jpg" alt="加值畫面"></figure>
                                        <figure><img src="@/assets/images/faq/recharge_2_3.jpg" alt="購買"></figure>
                                    </div>
                                    <p>
                                        ※ 目前本平台僅支援於「一刻鯨選」 App 內購買點數、兌換課程。
                                    </p>
                                </div>
                            </li>
                            <li class="faq_purchase">
                                <a class="toggle" href="javascript:void(0);">我要怎麼知道購買成功？</a>
                                <div class="inner">
                                    <p>
                                        方法一：<br>
                                        當您在「一刻鯨選」App 購買點數成功時，會有「購買成功」的提示。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><img src="@/assets/images/faq/success_1_1.jpg" alt="購買成功"></figure>
                                    </div>
                                    <p>
                                        方法二：<br>
                                        點選「一刻鯨選」 App 下方的「設定」<span class="img"><img src="@/assets/images/faq/icon1_1_1.png" alt="設定"></span>，再點選「交易記錄」就可以看到所有的交易資訊。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><img src="@/assets/images/faq/success_2_2.jpg" alt="我的"></figure>
                                        <figure><img src="@/assets/images/faq/success_2_3.jpg" alt="交易記錄"></figure>
                                    </div>
                                    <p>※ 目前本平台僅支援於「一刻鯨選」 App 內購買點數、兌換課程。</p>
                                </div>
                            </li>
                            <li class="faq_purchase">
                                <a class="toggle" href="javascript:void(0);">如何兌換課程？</a>
                                <div class="inner">
                                    <p>
                                        本平台每個課程都會提供試聽服務，建議您先試聽，確認該課程符合您的需求後，再購買點數來兌換課程，以取得收聽課程的權利。
                                    </p>
                                    <p>   
                                    <ol>
                                        <li>
                                            每個課程簡介都會標示需要兌換的點數，只要您有足額的點數，即可立即兌換。若點數不足時，也可直接購買點數來兌換課程。
                                        </li>
                                        <li>
                                            當您成功兌換後，下方會顯示「已購買」，您即可開始收聽該課程內容。
                                        </li>
                                    </ol>
                                    </p> 
                                    <div class="descriptionImg col_2">
                                        <figure><img src="@/assets/images/faq/purchase_1_1.jpg" alt="首頁"></figure>
                                        <figure><img src="@/assets/images/faq/purchase_1_2.jpg" alt="我的"></figure>
                                        <figure><img src="@/assets/images/faq/purchase_1_3.jpg" alt="交易記錄"></figure>
                                        <figure><img src="@/assets/images/faq/purchase_1_4.jpg" alt="交易記錄"></figure>
                                    </div>
                                    <p>※ 目前本平台僅支援於「一刻鯨選」 App 內購買點數、兌換課程。</p>
                                </div>
                            </li>
                            <li class="faq_purchase">
                                <a class="toggle" href="javascript:void(0);">從哪裡可以看到現在點數還剩多少？</a>
                                <div class="inner">
                                    <p>
                                        點選在「一刻鯨選」 App 下方的「設定」<span class="img"><img src="@/assets/images/faq/icon1_1_1.png" alt="設定"></span>，可在「錢包餘額」看到您目前擁有的點數。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><img src="@/assets/images/faq/point_1_1.jpg" alt="首頁"></figure>
                                    </div>
                                </div>
                            </li>
                            <li class="faq_purchase">
                                <a class="toggle" href="javascript:void(0);">我要怎麼看到已經購買的課程？</a>
                                <div class="inner">
                                    <p>
                                        在「一刻鯨選」 App 下方的「我聽」<span class="img"><img src="@/assets/images/faq/icon_mylist.png" alt="我聽"></span>，並點選「已購買課程」，可以看到您已經購買的所有課程。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><img src="@/assets/images/faq/bought_1_1.jpg" alt="首頁"></figure>
                                    </div>
                                </div>
                            </li>

                            <!-- 退費 li class="faq_refund"-->
                            <li class="faq_refund">
                                <a class="toggle" href="javascript:void(0);">我想退費可以嗎？</a>
                                <div class="inner">
                                    <p>
                                        有關退費的完整說明，您可以參考服務條款<a href="https://jinfm.net/terms" target="_blank">服務條款</a>的<a href="terms.html#RequestRefund" target="_blank">《退款政策》</a>。
                                    </p>
                                    <p>
                                    <ol>
                                        <li>
                                            本平台屬於數位內容智慧財產權產品，且皆有提供用戶免費試聽內容，故不適用《消費者保護法》第十九條第一項規定之七天內解約權（七天鑑賞期）。（依據「通訊交易解除權合理例外情事適用準則」第二條）
                                        </li>
                                        <li>
                                            點數一旦兌換課程，我們即無法接受您的退款要求。
                                        </li>
                                        <li>
                                            如果您透過 Google Play 或 Apple 的 App 內購買點數，可依循該服務商的退款流程進行申請：
                                            <ul>
                                                <li>
                                                    Apple 「App 內購買」點數：若您想申請退款，請與 Apple 官方支援小組聯繫，您可透過<a href="https://idmsa.apple.com/IDMSWebAuth/signin?appIdKey=6f59402f11d3e2234be5b88bf1c96e1e453a875aec205272add55157582a9f61&path=%2F%3Fs%3D4&language=TW-ZH" target="_blank">這裡</a>向 Apple 申請退款。是否能順利退款，決定權在於 Apple 方，他們會由人工審核，建議詳述原因讓 Apple 人員明白。
                                                    <br>
                                                    注意：申請退款僅能在購買點數的 90 天內，超過 90 天後 Apple 將不予受理。
                                                    <br>
                                                    ※ 更多說明請參考：<a href="https://support.apple.com/zh-tw/HT204084" target="_blank">https://support.apple.com/zh-tw/HT204084</a>
                                                </li>
                                                <li>
                                                    Google Play 「應用程式內購」點數：若距離您購買點數的時間尚未超過 48 小時，可透過 Google Play 申請退款，您可以透過<a href="https://play.google.com/store/account?pli=1" target="_blank">這裡</a>向 Google Play 申請退款。
                                                    <br>
                                                    ※ 更多說明請參考：<a href="https://support.google.com/googleplay/answer/7205930" target="_blank">https://support.google.com/googleplay/answer/7205930</a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ol>
                                    </p>
                                </div>
                            </li>

                            <!-- App功能 li class="faq_function"-->
                            <li class="faq_function">
                                <a class="toggle" href="javascript:void(0);">安裝「一刻鯨選」 App 的系統需求？</a>
                                <div class="inner">
                                    <p>
                                        如果您的行動裝置滿足以下的作業系統需求，即可安裝「一刻鯨選」 App：
                                    </p>
                                    <p>
                                    <ul>
                                        <li>iOS 系統版本 iOS 10（含）以上</li>
                                        <li>Android 系統版本 Android 5（含）以上</li>
                                    </ul>
                                    </p>
                                </div>
                            </li>
                            <li class="faq_function">
                                <a class="toggle" href="javascript:void(0);">如何試聽課程？</a>
                                <div class="inner">
                                    <p>
                                        方法一：<br>
                                        在「一刻鯨選」 App 首頁的課程列表中，每個課程右下角都有<span class="img"><img src="@/assets/images/faq/icon_qa_btntrial.png" alt="試聽"></span>或<span class="img"><img src="@/assets/images/faq/icon_qa_btnfree.png" alt="免費"></span>的按鈕，點選按鈕就可以試聽該課程的內容。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/demo_1_1.jpg" alt="首頁"></figure>
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/demo_1_2.jpg" alt="迷你播放器"></figure>
                                    </div>
                                    <p>
                                        方法二：<br>
                                        點選「一刻鯨選」 App 課程簡介左下角的「試聽<span class="img"><img src="@/assets/images/faq/icon_qa_play.png" alt="播放"></span>」鍵，即可快速試聽該課程。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/demo_2_1.jpg" alt="首頁試聽"></figure>
                                    </div>
                                    <p>
                                        方法三：<br>
                                        「一刻鯨選」 官網課程頁中，有「試聽內容」，點擊「播放」即可試聽。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/demo_3_1.jpg" alt="首頁試聽"></figure>
                                    </div>
                                </div>
                            </li>
                            <li class="faq_function">
                                <a class="toggle" href="javascript:void(0);">有什麼操作 App 播放器的撇步嗎？</a>
                                <div class="inner">    
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/play_1_1.jpg" alt="迷你播放器">【迷你播放器】模式</figure>
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/play_1_2.jpg" alt="全螢幕播放面板">【全螢幕播放面板】模式</figure>
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/play_1_3.jpg" alt="背景播放">【背景播放】模式</figure>
                                    </div>
                                    <p>
                                        【迷你播放器】模式：<br>
                                        當您播放課程內容時，App 下方會出現黑色的迷你播放器，您可以選擇播放/暫停，或是關閉迷你播放器並停止播放。
                                    </p>
                                    <p>
                                        【全螢幕播放面板】模式：<br>
                                        當您點擊迷你播放器，會出現「現正播放」的全螢幕播放面板，您也可以透過下方功能選項查看課程列表與該課程的文稿，以及下載該課程，以便在沒有網路的情況下，也能收聽課程內容。
                                    </p>
                                    <p>
                                        【背景播放】模式：<br>
                                        若您正在播放課程時，離開「一刻鯨選」App（聯繫講師並未關閉 App），仍可持續在背景播放。您可在下拉通知欄中，直接操作播放器。
                                    </p>
                                    <p>
                                        ※ Android 小技巧～在 Android 裝置下拉通知欄，可透過「雙指向內撥動或向外撥動」的雙指手勢，來縮放播放器的介面模式。也可在暫停播放時，透過「向左滑或向右滑」的單指手勢將播放器關閉。
                                    </p>

                                    <div class="descriptionImg col">
                                        <figure><figcaption>雙指向外撥動</figcaption><img src="@/assets/images/faq/play_2_1_Android.png" alt="雙指向外撥動"></figure>
                                        <figure><figcaption>雙指向內撥動</figcaption><img src="@/assets/images/faq/play_2_2_Android.png" alt="雙指向內撥動"></figure>
                                    </div>
                                </div>
                            </li>
                            <li class="faq_function">
                                <a class="toggle" href="javascript:void(0);">如何下載課程內容？</a>
                                <div class="inner">
                                    <p>
                                        方法一：<br>
                                        在「一刻鯨選」App 課程簡介的音頻列表中，點選「下載管理」，點選<span class="img"><img src="@/assets/images/faq/icon_qa_download.png" alt="下載"></span>即可下載單一音頻，或點擊「全部下載」一次下載所有課程內容。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/download_1_1.jpg" alt="課程頁面"></figure>
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/download_1_2.jpg" alt="下載管理"></figure>
                                    </div>
                                    <p>
                                        方法二：<br>
                                        在「一刻鯨選」App 「現正播放」的全螢幕播放面板中，點選「下載」<span class="img"><img src="@/assets/images/faq/icon_qa_download.png" alt="下載"></span>鍵，即可開始下載。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/download_2_1.jpg" alt="播放面板"></figure>
                                    </div>
                                </div>
                            </li>
                            <li class="faq_function">
                                <a class="toggle" href="javascript:void(0);">我如何找到下載課程的紀錄，並且刪除下載內容？</a>
                                <div class="inner">
                                    <p>
                                        方法一：<br>
                                        請點選在「一刻鯨選」 App 下方的「設定」<span class="img"><img src="@/assets/images/faq/icon1_1_1.png" alt="設定"></span>，然後點選「下載管理」，你可以在此查看下載課程的歷史紀錄。點選欲刪除的課程，在課程的音頻列表中有出現<span class="img"><img src="@/assets/images/faq/icon_qa_delete.png" alt="刪除"></span>，是您已經下載的音頻，點選即可刪除單一音頻，或點擊「全部刪除」一次刪除該課程所有已下載的內容。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/downloaded_1_1.jpg" alt="我的"></figure>
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/downloaded_1_2.jpg" alt="下載管理"></figure>
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/downloaded_1_3.jpg" alt="下載管理"></figure>
                                    </div>
                                    <p>
                                        方法二：<br>
                                       在「一刻鯨選」App 課程簡介的音頻列表中，點選「下載管理」，列表中有<span class="img"><img src="@/assets/images/faq/icon_qa_delete.png" alt="下載"></span>的音頻，是您已經下載的內容，點選即可刪除。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/downloaded_2_1.jpg" alt="課程頁面"></figure>
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/downloaded_2_2.jpg" alt="下載管理"></figure>
                                    </div>
                                </div>
                            </li>
                            <li class="faq_function">
                                <a class="toggle" href="javascript:void(0);">為何有些人的 App 畫面是藍色系的？有些人是白色系的？能夠自己設定嗎？</a>
                                <div class="inner">
                                    <p>
                                        我們提供兩種風格（日光版與深海版），可讓您自由選用。請點選「一刻鯨選」 App 下方的「設定」<span class="img"><img src="@/assets/images/faq/icon1_1_1.png" alt="設定"></span>，然後點選「其他設定」<span class="img"><img src="@/assets/images/faq/icon_qa_setting.png" alt="設定"></span>，再點選「外觀選擇」，您即可依照個人的喜好更換 App 的外觀風格。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/interface_1_1.jpg" alt="我的"></figure>
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/interface_1_2.jpg" alt="設定"></figure>
                                    </div>
                                </div>
                            </li>
                            <li class="faq_function">
                                <a class="toggle" href="javascript:void(0);">如何更改語系？</a>
                                <div class="inner">
                                    <p>
                                        請點選在「一刻鯨選」 App 下方的「設定」<span class="img"><img src="@/assets/images/faq/icon1_1_1.png" alt="設定"></span>，然後選擇「其他設定」<span class="img"><img src="@/assets/images/faq/icon_qa_setting.png" alt="設定"></span>，在設定頁面中，請點選「語系切換」。目前我們支援「繁體」與「簡體」兩種語系。
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/language_1_1.jpg" alt="我的"></figure>
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/language_1_2.jpg" alt="下載管理"></figure>
                                    </div>
                                </div>
                            </li>
                            <li class="faq_function">
                                <a class="toggle" href="javascript:void(0);">如何修改自己的暱稱？</a>
                                <div class="inner">
                                    <p>
                                        請點選在「一刻鯨選」 App 下方的「設定」<span class="img"><img src="@/assets/images/faq/icon1_1_1.png" alt="設定"></span>，選擇<span class="img"><img src="@/assets/images/faq/icon_qa_edit.png" alt="編輯"></span>，即可修改您的暱稱。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/nickname_1_1.jpg" alt="首頁"></figure>
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/nickname_1_3.jpg" alt="編輯"></figure>
                                    </div>
                                </div>
                            </li>
                            <li class="faq_function">
                                <a class="toggle" href="javascript:void(0);">請問怎樣才能開啟或關閉推播通知？</a>
                                <div class="inner">
                                    <p>
                                        請點選在「一刻鯨選」 App 下方的「設定」<span class="img"><img src="@/assets/images/faq/icon1_1_1.png" alt="設定"></span>，然後點選「其他設定」<span class="img"><img src="@/assets/images/faq/icon_qa_setting.png" alt="設定"></span>，在設定列表中點選「推播通知」的開關按鈕，選擇開啟 / 關閉通知。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/notificationiOS_1_1.jpg" alt="首頁"></figure>
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/notificationiOS_1_3.jpg" alt="編輯"></figure>
                                    </div>
                                </div>
                            </li>

                            <!-- 登入 li class="faq_login"-->
                            <li class="faq_login">
                                <a class="toggle" href="javascript:void(0);">為什麼要登入？</a>
                                <div class="inner">
                                    <p>
                                        本平台部分功能或服務（例如：購買點數、兌換課程、有價課程收聽權利...等）需要您登入後才能使用。而您若是更換手機或是想要在其他裝置中使用本服務，也必須透過登入才能取回您已購買的點數與課程。為保障您的權利，建議您登入後使用本服務，以免造成您權益損失。
                                    </p>
                                </div>
                            </li>
                            <li class="faq_login">
                                <a class="toggle" href="javascript:void(0);">如何登入？</a>
                                <div class="inner">
                                    <p>
                                        請點選在「一刻鯨選」 App 下方的「設定」<span class="img"><img src="@/assets/images/faq/icon1_1_1.png" alt="設定"></span>，如您尚未登入，請點選「登入」。
                                    </p>
                                    <ul>
                                    <li>udn會員</li>
                                    <li>手機號碼</li>
                                    <li>Facebook 帳號</li>
                                    <li>Google 帳號</li><br>
                                    </ul>
                                    <p>
                                    請注意！不同的登入方式，將會產生不同的一刻鯨選用戶身分，而該用戶身分（ID）攸關到您的權利與資產（包含點數、交易紀錄…等），建議您選用一種方式進行登入。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/login_1_1.jpg" alt="首頁"></figure>
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/login_1_3.jpg" alt="登入"></figure>
                                    </div>
                                </div>
                            </li>
                            <li class="faq_login">
                                <a class="toggle" href="javascript:void(0);">忘記密碼怎麼辦？</a>
                                <div class="inner">
                                    <p>
                                        本平台的登入機制，支援多種帳號（udn會員、Facebook、Google）快速登入，因此當您忘記密碼時，請您回到該帳號平台選擇「忘記密碼」來重新設定。
                                    </p>
                                </div>
                            </li>
                            <li class="faq_login">
                                <a class="toggle" href="javascript:void(0);">如果更換新手機，能將帳號攜帶移轉嗎？</a>
                                <div class="inner">
                                    <ol>
                                    <li>
                                    當您用 Android / iOS 裝置使用服務時，必須使用可被識別的身份驗證（udn會員、Facebook、Google 帳號、手機號碼）購買點數；在您更換裝置或裝置損壞、遺失時，在新的裝置驗證身份後，即可重新取回您在本平台購買的付費服務權利。<br>
                                    惟因檔案容量問題，您必須在新手機重新下載課程。另外，在您的舊手機，下載過的課程仍然會保留，您可以繼續使用。
                                    </li>
                                    <li>
                                    若您用 iOS 裝置使用服務時，未登入上述任一驗證方式（udn會員、Facebook、Google 帳號、手機號碼）即購買，也就是購買時選擇「略過」、採用訪客身份購買，由於訪客身份無法被識別，所以當您更換手機，將無法取回您在本平台購買的付費服務權利。 <br>
                                    強烈建議您使用付費服務時，使用可被識別的身份驗證，以免喪失您的權利。
                                    </li>
                                    </ol>
                                </div>
                            </li>
                            <li class="faq_login">
                                <a class="toggle" href="javascript:void(0);">出現超過裝置訊息時，要如何處理？</a>
                                <div class="inner">
                                    <p>
                                        本平台提供使用者可同時在多個行動裝置，使用「一刻鯨選」App 的服務。
                                    </p>
                                    <p>
                                        當 App 出現超過裝置訊息時，您可以截圖並寄到客服信箱，我們將會為您處理。
                                    </p>
                                    <p>
                                        ※ 您可以參考 <a href="https://jinfm.net/info" target="_blank">「服務條款-服務使用補充說明」</a><a href="info.html#DeviceAccess" target="_blank">《載具存取之限制》</a>。
                                    </p>
                                </div>
                            </li>
                            <li class="faq_login">
                                <a class="toggle" href="javascript:void(0);">如何找出一刻鯨選用戶身分（ID）呢？</a>
                                <div class="inner">
                                    <p>
                                        請點選在「一刻鯨選」 App 下方的「設定」<span class="img"><img src="@/assets/images/faq/icon1_1_1.png" alt="設定"></span>，點選暱稱下方的編輯，您可以在編輯頁裡面找到您的 ID 。
                                    </p>
                                    <p>
                                        請注意！此 ID 攸關您的使用者權益，請小心保管，請勿將 ID 提供給其他人。
                                    </p>
                                    <div class="descriptionImg">
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/myid_1_1.jpg" alt="首頁"></figure>
                                        <figure><figcaption></figcaption><img src="@/assets/images/faq/myid_1_3.jpg" alt="登入"></figure>
                                    </div>
                                </div>
                            </li>

                        </ul>


                        
                    </div>
                </div>
            </div>
            <!--常見問題結束-->

            


        </main>
        
        
    </div>    
</template>

<script>
export default {
     name: 'async',
    metaInfo () {
      return {
        
        title: '常見問題 | 一刻鯨選',
        meta: [
            // OpenGraph data (Most widely used)
            {property: 'og:title', content: '常見問題 | 一刻鯨選'},
            {property: 'og:site_name', content: '常見問題 | 一刻鯨選'},
            // The list of types is available here: http://ogp.me/#types
            {property: 'og:type', content: 'website'},
            // Should the the same as your canonical link, see below.
            {property: 'og:url', content: window.location.toString()},
            {property: 'og:image', content: this.$store.state.urlDomain+'/static/logo.jpg'},
            // Often the same as your meta description, but not always.
            {property: 'og:description', content: '關於一刻鯨選常見問題，或是想瞭解一刻鯨選的服務內容、使用方式，都能在此找到解答。'},
        
        ]
      }
    },
  
 data() {
    return {
       classData: [],
    }
  },
 methods: {
       

　　},
    mounted() {
        // 分類
            $('.faq .category li').click( function(){
                if ( $(this).hasClass('current') ) {
                    $(this).removeClass('current');
                } else {
                    $('.faq .category li.current').removeClass('current');
                    $(this).addClass('current');    
                }
            });

            
            $("#faq_all").click(function () {
                $('ul.accordion > li').hide();
                $("ul.accordion > li").fadeIn(300);
            });
            // var classNames = $("#myDiv").attr("class").split(' ');
            $("#faq_about").click(function () {
                $('ul.accordion > li').hide();
                $("ul.accordion > li").filter(".faq_about").fadeIn(300);
            });
            $("#faq_lecture").click(function () {
                $('ul.accordion > li').hide();
                $("ul.accordion > li").filter(".faq_lecture").fadeIn(300);
            });
            $("#faq_purchase").click(function () {
                $('ul.accordion > li').hide();
                $("ul.accordion > li").filter(".faq_purchase").fadeIn(300);
            });
            $("#faq_refund").click(function () {
                $('ul.accordion > li').hide();
                $("ul.accordion > li").filter(".faq_refund").fadeIn(300);
            });
            $("#faq_function").click(function () {
                $('ul.accordion > li').hide();
                $("ul.accordion > li").filter(".faq_function").fadeIn(300);
            });
            $("#faq_login").click(function () {
                $('ul.accordion > li').hide();
                $("ul.accordion > li").filter(".faq_login").fadeIn(300);
            });

            // accordion
            $('.toggle').click(function(e) {
                e.preventDefault();
              
                var $this = $(this);

                setTimeout(function() {
                    theOffset = $this.offset();
                    $('body,html').animate({ scrollTop: theOffset.top - 200 });
                }, 310);
              
                if ($this.parent().hasClass('show')) {
                    $this.parent().removeClass('show');
                    $this.next().slideUp(350);
                } else {
                    $this.parent().parent().find('li').removeClass('show');
                    $this.parent().parent().find('li .inner').slideUp(350);
                    $this.parent().toggleClass('show');
                    $this.next().slideToggle(350);
                }
            });

      }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/Help.vue